// Pushes events consumed by Google Tag Manager triggers (see GTM container config for the
// corresponding Google Ads conversion tags).
export const ConversionEvents = {
  VACANCY_VIEW: "vacancy_view",
  APPLICATION_START: "application_start",
  APPLICATION_SUBMIT: "application_submit",
} as const;

type ConversionEvent = ObjectValues<typeof ConversionEvents>;

export const pushConversionEvent = (
  event: ConversionEvent,
  payload?: Record<string, unknown>,
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
};
